import React from "react";

const ProfileModal = ({ onClose }) => {
  const user = JSON.parse(localStorage.getItem("user"))
  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h3>User Profile</h3>
        <p><strong>Name:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Role:</strong> {user.role}</p>
        <button onClick={onClose} className="btn btn-secondary">Close</button>
      </div>
    </div>
  );
};

export default ProfileModal;
